export default __webpack_public_path__ + "static/media/aboutjmimg.6c43f1e9.png";